export function transformLocale() {
    return [
        { name: "Наличные", type: "CASH" },
        { name: "Карта", type: "CARD" },
        { name: "A-PAY", type: "APAY" },
        { name: "Другие", type: "OTHER" },
        { name: "HUMO", type: "HUMO" },
        { name: "Карта лояльности", type: "LOYALTY_CARD" },
        { name: "Электронный кошелек A-PAY", type: "EPAYMENT" },
        { name: "UZCARD", type: "UZCARD" },
    ];
}